__turbopack_context__.v({
  "check": "WorkspaceListFilter-module__GDTfRG__check",
  "count": "WorkspaceListFilter-module__GDTfRG__count",
  "label": "WorkspaceListFilter-module__GDTfRG__label",
  "menu": "WorkspaceListFilter-module__GDTfRG__menu",
  "root": "WorkspaceListFilter-module__GDTfRG__root",
  "trigger": "WorkspaceListFilter-module__GDTfRG__trigger",
  "value": "WorkspaceListFilter-module__GDTfRG__value",
});
